<template>
  <div>
    <div>
      <b-table
        :fields="fields"
        :busy="getProcessingEmployees"
        :items="getEmployeesGES.data"
        class="col-12 mt-5 p-0 table-view-employees-risk"
        show-empty
      >
        <template #cell(name)="row">
          {{ row.item.name }}<br />
          <b>c.c. {{ row.item.cc }}</b>
        </template>
        <template #table-busy>
          <div class="text-center my-2 mb-3">
            <OverlayButton clase="overlay-md"></OverlayButton>
          </div>
        </template>
        <template #empty>
          <div class="text-center my-2">
            <h2>Sin datos para mostrar</h2>
          </div>
        </template>
        <template #cell(option)="">
          <div>
            <button class="button-concept">
              Ver conceptos médicos
              <img
                :src="require('@/assets/images/icons/eye-line.svg')"
              />
            </button>
          </div>
        </template>
      </b-table>
      <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
        <Pagination
          :data="getEmployeesGES"
          :limit="10"
          @pagination-change-page="paginateEmployeeGES"
        >
        </Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";

export default {
  components: {
    OverlayButton,
    Pagination,
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Nombre / C.C",
          sortable: true,
        },
        {
          key: "charge",
          label: "Cargo",
          sortable: true,
        },
        {
          key: "area",
          label: "Área",
          sortable: true,
        },
        {
          key: "health_condition",
          label: "Condición de salud",
          sortable: true,
        },
        {
          key: "option",
          label: "",
        },
      ],
      page: 1,
    };
  },
  computed: {
    ...mapGetters("htGes", ["getProcessingEmployees", "getEmployeesGES"]),
    ...mapState("modSVE", ["loading"]),
  },
  methods: {
    ...mapActions("htGes", [
      "indexEmployee",
    ]),
    paginateEmployeeGES(page = 1) {
      const me = this;
      me.page = page;
      me.indexEmployee({ id: me.ges.id, values: { page } });
    },
  },
};
</script>

<style lang="scss">
.table-view-employees-risk {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
  text-align: left !important;
}
.table-view-employees-risk thead {
  border-radius: 0 !important;
  border: none !important;
}

.table-view-employees-risk thead th {
  border-bottom: none !important;
}

.table-view-employees-risk .table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #e3e4fc !important;
  border: none !important;
}
.table-view-employees-risk .button-concept {
  border: none;
  background-color: white;
  color: #5D5FEF;
  font-weight: 700;
  font-size: 16px;
}
</style>
